// @flow

import { Component } from '../jsti/core';
import Notifications from '../constants/Notifications';
import EventNames from '../constants/EventNames';

export default class PopupModalButton extends Component {
  clickHandler: function;

  /**
   * Initialize the component
   *
   * @param pEl
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);

    this.clickHandler = this.handleClickEvents.bind(this);
    this.addEventListener(EventNames.CLICK, this.clickHandler);
  }

  /**
   * Let the modal know that it can be toggled
   *
   * @param e
   */
  handleClickEvents(e: Event): void {
    e.preventDefault();
    this.notify(Notifications.TOGGLE_MODAL, { id: this.el.dataset.id });
  }
}
